import React, { useMemo } from "react";

import { financialHeaders, financialDefaultColumns } from "./constants";
import { EditableTable } from "./editableTable";
import { mapToEditableRows } from "./helpers";

import styles from "./tables.module.scss";

const FinancialTable = ({
	financials,
	addFinancial,
	editFinancial,
	deleteFinancial,
	handlePageChange,
	count,
	page,
	isEditable = true,
	showEmptyBlock,
	dateFormat = "MM/DD/YYYY",
	hideFooter,
	loading,
}) => {
	const rows = useMemo(
		() =>
			mapToEditableRows(financials, financialDefaultColumns, dateFormat),
		[financials, dateFormat],
	);

	return (
		<EditableTable
			rows={rows}
			loading={loading}
			dateFormat={dateFormat}
			headers={financialHeaders}
			columnsStructure={financialDefaultColumns}
			useFirstRowForAddition={isEditable}
			className={styles.financialTable}
			headerClassName={
				isEditable ? styles.wrapHeaderWithAction : styles.wrapHeader
			}
			bodyClassName={styles.wrapBody}
			actionsClassName={styles.actions}
			inputFieldColSize={12}
			onAdd={addFinancial}
			onEdit={editFinancial}
			onDelete={deleteFinancial}
			isEditable={isEditable}
			showEmptyBlock={showEmptyBlock}
			hideFooter={hideFooter}
			count={count}
			page={page}
			handlePageChange={handlePageChange}
		/>
	);
};

export default FinancialTable;
